import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from "react-router-dom";
import { getAuthToken } from "../services/apiClient";
import {
  connectChatSocket,
  normalizeSocketMessage,
} from "../services/chatService";
import Notification from '../modal/NotificationModal';

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const pageTitles = {
    "/dashboard": "Dashboard",
    "/archives": "Archives",
    "/products": "Medications",
    "/otc": "OTC",
    "/billing": "Billing",
    "/change-password": "Change Password",
    "/users": "Users",
    "/chat": "Chat",
    "/notifications": "Notifications",
    "/all-notifications": "All Notifications",
    "/settings": "Settings",
    "/settings/categories": "OTC Categories",
    "/settings/kupat-holims": "Kupat Holim Settings",
  };
  let pageTitle = pageTitles[location.pathname] || "Kare Admin";
  if (location.pathname === "/products/new") pageTitle = "Add Medication";
  else if (location.pathname.match(/^\/products\/[^/]+\/edit$/)) pageTitle = "Edit Medication";
  else if (location.pathname === "/otc/new") pageTitle = "Add OTC Medication";
  else if (location.pathname.match(/^\/otc\/[^/]+\/edit$/)) pageTitle = "Edit OTC Medication";
  else if (location.pathname.startsWith("/products/")) pageTitle = "Medications";
  else if (location.pathname.startsWith("/otc/")) pageTitle = "OTC";
  const pageAction = {
    "/products": { label: "Add medication", action: "create", icon: "+" },
    "/otc": { label: "Add OTC product", action: "create", icon: "+" },
    "/billing": { label: "Create billing", action: "create-billing", icon: "+" },
    "/users": { label: "Create user", action: "create-user", icon: "+" },
    "/settings/categories": { label: "Add Category", action: "create", icon: "+" },
    "/notifications": { label: "Refresh", action: "refresh", icon: "↻" },
    "/all-notifications": { label: "Refresh", action: "refresh", icon: "↻" },
  }[location.pathname];
  const importAction = location.pathname === "/products"
    ? { label: "Import CSV / Excel", action: "import", icon: "↑" }
    : null;
  const pageFilter = null;
  const [searchTerm, setSearchTerm] = useState("");
  const [filterValue, setFilterValue] = useState("");

  useEffect(() => {
    setSearchTerm("");
    setFilterValue("");
  }, [location.pathname]);

  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchTerm(query);
    window.dispatchEvent(
      new CustomEvent("admin-page-search", {
        detail: { path: location.pathname, query },
      }),
    );
  };

  const handlePageAction = (action = pageAction?.action) => {
    window.dispatchEvent(new CustomEvent("admin-page-action", {
      detail: { path: location.pathname, action },
    }));
  };

  const handleFilterChange = (event) => {
    const value = event.target.value;
    setFilterValue(value);
    window.dispatchEvent(new CustomEvent("admin-page-filter", {
      detail: { path: location.pathname, key: "role", value },
    }));
  };

  useEffect(() => {
    const token = getAuthToken();
    if (!token) return undefined;

    const socket = connectChatSocket(token);
    if (!socket) return undefined;

    const handleNewMessage = (incomingMessage) => {
      const normalizedMessage = normalizeSocketMessage(incomingMessage);
      const notification = {
        id: `chat-${normalizedMessage.id || Date.now()}`,
        title: "New chat message",
        message: normalizedMessage.message || "You have a new message",
        createdAt: normalizedMessage.createdAt,
        unread: true,
      };

      window.dispatchEvent(
        new CustomEvent("chat-notification", {
          detail: {
            ...notification,
            normalizedMessage,
          },
        }),
      );
    };

    socket.on("new_message", handleNewMessage);

    return () => {
      socket.off("new_message", handleNewMessage);
    };
  }, []);

  return (
    <header className="top-header">
            <div className="header-right-menu">
                <div className="header-page-context">
                    <button type="button" className="header-back-button" aria-label="Go back" onClick={() => navigate(-1)}><i className="bi bi-arrow-left"></i></button>
                    <div>
                        <span>Admin workspace</span>
                        <strong>{pageTitle}</strong>
                    </div>
                </div>
                <div className="page-header-right-links">
                    <form className="search-form" onSubmit={(event) => event.preventDefault()}>
                        <div className="input-group">
                            <div className="input-group-text">
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>
                            </div>
                            <input value={searchTerm} onChange={handleSearchChange} placeholder={`Search ${pageTitle.toLowerCase()}…`} className="ps-2 form-control" type="search" aria-label={`Search ${pageTitle}`} />
                        </div>
                    </form>
                    {pageFilter && <select className="header-page-filter" value={filterValue} onChange={handleFilterChange} aria-label={pageFilter.label}>{pageFilter.options.map((option) => <option key={option.value} value={option.value}>{option.label}</option>)}</select>}
                    {importAction && <button type="button" className="header-page-action header-page-import" onClick={() => handlePageAction(importAction.action)}><span>{importAction.icon}</span>{importAction.label}</button>}
                    {pageAction && <button type="button" className="header-page-action" onClick={() => handlePageAction()}><span>{pageAction.icon}</span>{pageAction.label}</button>}
                    <Notification />
                </div>
            </div>
    </header>
  )
}

export default Header
